import { render, staticRenderFns } from "./IncomeDetailsStep.component.vue?vue&type=template&id=292d2b18&"
import script from "./IncomeDetailsStep.component.vue?vue&type=script&lang=ts&"
export * from "./IncomeDetailsStep.component.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeDetailsStep.component.vue?vue&type=style&index=0&id=292d2b18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports